import { render, staticRenderFns } from "./parcel-detail-header.vue?vue&type=template&id=443cb040"
import script from "./parcel-detail-header.vue?vue&type=script&lang=js"
export * from "./parcel-detail-header.vue?vue&type=script&lang=js"
import style0 from "./parcel-detail-header.vue?vue&type=style&index=0&id=443cb040&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports